import {IconAlertCircle} from "@tabler/icons";
import {Alert} from "@mantine/core";

export function handleHTTPError(status: number, message: string) {
    let prefix = status.toString()[0];

    switch (prefix) {
        case '2':
            return (
                <Alert icon={<IconAlertCircle size="1rem" />} title="Success!" color="green" radius="md">
                    {message}
                </Alert>
            );
        case '4':
            return (
                <Alert icon={<IconAlertCircle size="1rem" />} title="Something is wrong with your request!" color="orange" radius="md">
                    {message}
                </Alert>
            );
        case '5':
            return (
                <Alert icon={<IconAlertCircle size="1rem" />} title="Error!" color="red" radius="md">
                    An internal error has occurred while processing your request, the issue has been logged! Please try again later.
                </Alert>
            );
        default:
            return (
                <Alert icon={<IconAlertCircle size="1rem" />} title="Error!" color="red" radius="md">
                    An unknown error has occurred, please try again later.
                </Alert>
            );
    }
}